import { Moment } from 'moment';
import User from '@/shared/models/User';

export default class SurveyFeedback {
  comment: string | null = null;
  modifiedOn: Moment | null = null;
  modifiedBy: User | null = null;
}
